angular
    .module('empower.control')
    .directive("timepicker", ['$rootScope', function ($rootScope) {
        return {
            restrict: 'A',
            require: "ngModel",
            scope: {
                ngModel: '='
            },
            link: function (scope, element, attr) {
                $(element).timepicker({
                    timeFormat:'HH:mm',
                    interval: 10,
                    dynamic:true,
                    dropdown: true,
                    scrollbar:true,
                    change: function(time) {
                        var timepicker = element.timepicker();
                        scope.$apply(function() { 
                            scope.ngModel = timepicker.format(time);
                         });
                    }
                });
            }
        };

    }]);
